import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
  interface Props {
    paragraphs: string[];
    animationImg?: string;
    animationText?: string;
    title: string;
    label: string;
    image: string;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'LandingSection',
  props: {
    paragraphs: {},
    animationImg: {},
    animationText: {},
    title: {},
    label: {},
    image: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;
  const paragraphAnimation = computed(() => {
    return {
      name: props.animationText,
    };
  });

const __returned__ = { props, paragraphAnimation, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})